import { PracticePitcherSessionReportChartConfigDto, PitcherStatsByPitchType, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const disabledVisibleStats: (keyof PitcherStatsByPitchType)[] = ['pitchType'];

const PracticePitcherSessionStatsByPitchTypeChartSidebar = (
  props: ChartConfigProps<TableChartConfigDto, PracticePitcherSessionReportChartConfigDto>
) => {
  return (
    <TableChartSidebar
      chartId='PracticePitcherSessionStatsByPitchTypeChart'
      configKey='practicePitcherSessionStatsByPitchTypeChartConfig'
      disabledVisibleStats={disabledVisibleStats}
      {...props}
    />
  );
};

export default PracticePitcherSessionStatsByPitchTypeChartSidebar;
